import styled from 'styled-components';

const MainNavStyled = styled.nav`
  max-width: 1280px;
  width: 100%;
  min-height: 60px;
  display: flex;
  margin: 0 auto;
  @media (min-width: 769px) {
    padding-right: 20px;
  }

  &.nav_row {
    justify-content: space-between;
    align-items: center;
    z-index: 97;
    @media (max-width: 768px) {
      padding: 0 15px;
    }
  }
  button.main_nav-logo-container {
    width: 30%;
    padding: 0px;

    padding-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    border: 0px;
    @media (max-width: 768px) {
      width: auto;
      padding: 0;
    }
    .logo-nav {
      transition: transform 0.3s;
      cursor: pointer;
      @media (max-width: 768px) {
        display: none;
      }
    }
    .user-details {
      display: none;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      @media (max-width: 768px) {
        display: flex;
      }
      .details-text {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        min-width: 140px;
        padding-left: 10px;
        h2 {
          font-size: 13px;
          color: #ffffff;
          font-weight: 600;
          line-height: 17px;
        }
        p {
          font-size: 13px;
          color: #bbadc3;
          font-weight: 300;
          line-height: 17px;
        }
      }
    }
  }
`;

const SecondNavStyled = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 0 auto;
`;

const NavItemStyled = styled.li`
  display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'flex')};
  margin-right: 20px;

  @media (min-width: 769px) {
    display: flex;
    margin-right: 0;
    & + & {
      :before {
        content: '';
        border-left: 1px solid white;
        height: 32px;
        margin: 0 20px;
      }
    }
  }
`;

const NavLinkStyled = styled.a`
  color: #ffffff;
  text-decoration: none;
  :hover {
    cursor: pointer;
  }
`;

const NameLettersStyled = styled.p`
  background-color: #4d008c;
  border-radius: 50%;
  color: #a67fc5;
  display: flex;
  font-size: 20px;
  font-weight: 700;
  height: 35px;
  margin-bottom: 10px;
  place-content: center;
  place-items: center;
  width: 35px;
`;

export {
  MainNavStyled,
  SecondNavStyled,
  NavItemStyled,
  NavLinkStyled,
  NameLettersStyled,
};
